import {PropsWithChildren, ReactElement} from "react";
import classNames from "classnames";
import "./Tag.scss";

/**
 * Tag / chip. Themed self-contained colour palette (dp-tag--*) — no dependency
 * on the retired legacy button colour SCSS. Legacy colour keys are kept as the
 * public API and mapped to the themed variants below.
 */
type TagColor =
    "purple" | "gray" | "gray-light" | "ghost" | "danger" | "success"
    | "warning" | "dark" | "white-outline" | "white-drop-shadow";

/*
 * Legacy colour keys → themed tag variants. Red is reserved for live/primary
 * state per the design guide, so the legacy "purple" brand accent maps to a
 * neutral chip — only the semantic danger/success/warning keys carry colour.
 */
const TAG_VARIANT: Record<TagColor, string> = {
    "purple": "neutral", "gray": "neutral", "gray-light": "neutral", "ghost": "neutral",
    "dark": "neutral", "white-outline": "neutral", "white-drop-shadow": "neutral",
    "danger": "danger", "success": "success", "warning": "warning",
};

interface Props {
    name: string;
    color?: TagColor;
    rounded?: boolean;
    className?: string;
}

function Tag(props: PropsWithChildren<Props>): ReactElement {

    const fullClassNames: string = classNames(
        "dp-tag",
        props.color ? `dp-tag--${TAG_VARIANT[props.color]}` : "dp-tag--neutral",
        props.className,
        props.rounded ? "dp-tag--rounded" : undefined,
    );

    return (
        <div className={fullClassNames}>
            <p>
                {props.name}
            </p>
        </div>
    );
}

export default Tag;
